import{a as o,b as p}from"./chunk-VTRYZJDB.mjs";import{applyBoxStyles as x}from"@refract-ui/core";var r=o.div`
  ${({theme:e,...t})=>x(e.box,t)}
`,m=r;export{m as a};
